module.exports = __webpack_public_path__ + "media/flags/bn-dcf92219.svg";